import Menu from "./Menu";
import { MainContainerStyled } from "./style";

const Main = () => {
  return (
    <MainContainerStyled>
      <Menu />
      <h1 className="text">teste</h1>
    </MainContainerStyled>
  );
};

export default Main;
